import localforage from 'localforage';
const clearIndexedDB = async () => {
  try {
    await localforage.clear();
    console.log('LocalForage IndexedDB has been cleared.');
  } catch (error) {
    console.error('Error clearing LocalForage:', error);
  }
};
const clearCache = async () => {
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames.map((cacheName) => {
        return caches.delete(cacheName);
      }),
    );
    console.log('Cache has been cleared.');
  }
};
export const clearAllStorage = async () => {
  localStorage.clear();
  sessionStorage.clear();
  console.log('Local Storage and Session Storage cleared.');
  await clearIndexedDB();
  await clearCache();
};
